import { render, staticRenderFns } from "./CommunicationTracking.vue?vue&type=template&id=40c567e4&scoped=true&"
import script from "./CommunicationTracking.vue?vue&type=script&lang=js&"
export * from "./CommunicationTracking.vue?vue&type=script&lang=js&"
import style0 from "./CommunicationTracking.vue?vue&type=style&index=0&id=40c567e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c567e4",
  null
  
)

export default component.exports